import { obterHtml } from './v2/api';
import { formatar, textos, url } from './v2/config';
import { iniciarAutocomplete } from './v2/campoBusca';
import { buscasRecentes, escolherLocal, guardarBuscaRecente, localDaConexao, localEscolhido, ondeParou, pedirLocalizacao, slug, slugDoLocal, urlBusca } from './v2/local';
import { iniciarMedicaoPagina } from './v2/medicao';
import { avisarErro } from './v2/aviso';
import { irPara } from './v2/sobreposicao';
import { obterUsuario } from './v2/usuario';
import { abrirSov, fecharSov, icone, iniciarBuscaTelaCheia, textosBusca } from './v2/buscaTelaCheia';
import { ocupado, ocupar } from './v2/botao';

const pagina = document.getElementById('home-v2');
const t = textos(pagina);
const ehCelular = () => !window.matchMedia('(min-width: 960px)').matches;
const $ = id => document.getElementById(id);

// Clique com Ctrl/Cmd/Shift ou botão do meio abre o link em outra aba: não interceptar.
const cliqueComum = e => e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey;

// ---------- local da pessoa: o escolhido neste aparelho ou o da conexão ----------
let _localAtual = localEscolhido() || localDaConexao();
let _escolheuNaPagina = false;
const obterLocal = ({ soConexao = false } = {}) => (soConexao ? localDaConexao() : _localAtual);
// O escolhido na sugestão aparece com o rótulo dela ("São Paulo · SP"), como na v36.
const _textoDoLocal = local => (local ? local.rotulo || local.nome : '');

function _mostrarLocal(local) {
    const texto = _textoDoLocal(local);
    if ($('homeL') && document.activeElement !== $('homeL')) {
        $('homeL').value = texto;
    }
    if ($('mpillL')) {
        $('mpillL').textContent = texto || $('mpillL').dataset.padrao;
    }
}

// ---------- empresas contratando e alerta: o HTML do servidor é a versão nacional (cache sem Vary) ----------
let _controlador = null;

function _parametros(local) {
    if (!local) {
        return '';
    }
    if (local.tipo === 'ponto') {
        // 2 casas (~1 km), como a busca: cada ponto cru seria uma chave nova na borda.
        return `&lat=${Number(local.lat).toFixed(2)}&lon=${Number(local.lon).toFixed(2)}`;
    }
    return `&localidade=${encodeURIComponent(local.nome)}`;
}

async function _carregarLocal(local) {
    const bloco = $('home-local');
    if (!bloco) {
        return;
    }
    _controlador?.abort();
    const controlador = new AbortController();
    _controlador = controlador;
    bloco.setAttribute('aria-busy', 'true');
    try {
        // Pedaço com URL própria (parcial na query), nunca separado por cabeçalho: a borda guarda pela URL.
        const html = await obterHtml(url(`?parcial=local${_parametros(local)}`), { sinal: controlador.signal });
        const modelo = document.createElement('template');
        modelo.innerHTML = html;
        const novo = modelo.content.getElementById('home-local');
        if (novo) {
            bloco.replaceWith(novo);
        }
    } catch {
        // Cancelado ou falhou: fica o bloco que estava.
    } finally {
        if (_controlador === controlador) {
            $('home-local')?.removeAttribute('aria-busy');
        }
    }
}

function _trocarLocal(local) {
    _escolheuNaPagina = true;
    _localAtual = local;
    escolherLocal(local);
    _mostrarLocal(local);
    _carregarLocal(local);
}

// ---------- buscar ----------
function _localDoTexto(texto) {
    texto = (texto || '').trim();
    if (!texto) {
        return null;
    }
    if (_localAtual && (texto === _localAtual.nome || texto === _localAtual.rotulo)) {
        return _localAtual.tipo === 'ponto'
            ? (_localAtual.cidade ? { nome: _localAtual.cidade, slug: slugDoLocal(_localAtual.cidade) } : null)
            : { nome: _localAtual.nome, slug: _localAtual.slug || slugDoLocal(_localAtual.nome) };
    }
    return { nome: texto, slug: slugDoLocal(texto) };
}

function _buscar(cargo, textoLocal) {
    const local = _localDoTexto(textoLocal);
    guardarBuscaRecente(cargo, local?.nome || '');
    irPara(urlBusca(cargo, local));
}

async function _usarLocalizacao() {
    try {
        const ponto = await pedirLocalizacao();
        fecharSov();
        _trocarLocal({ tipo: 'ponto', origem: 'aparelho', nome: textosBusca.pertoDeVoce, ...ponto, cidade: localDaConexao()?.nome || '' });
    } catch {
        avisarErro(textosBusca.localizacaoNegada);
    }
}

// ---------- buscas recentes e "Continuar" ----------
function _desenharRecentes() {
    const caixa = $('homeRecent');
    const rotulo = $('recLbl');
    const recentes = buscasRecentes();
    if (!caixa || !recentes.length) {
        return;
    }
    const chip = (classe, nomeIcone, texto, sub, dados) => {
        const b = document.createElement('button');
        b.className = classe;
        b.type = 'button';
        Object.entries(dados).forEach(([k, v]) => { b.dataset[k] = v; });
        b.append(icone(nomeIcone), texto);
        if (sub) {
            const s = document.createElement('small');
            s.textContent = `· ${sub}`;
            b.append(' ', s);
        }
        return b;
    };
    const [q0, l0] = recentes[0];
    const curto = (l0 || '').split(',')[0].trim();
    // Se a última vaga aberta foi dessa busca, o "Continuar" volta para ela (com a vaga aberta).
    const parou = ondeParou();
    // Só caminho do próprio site ("/pt-br/..."): o valor vem do localStorage.
    const mesma = parou && /^\/[^/]/.test(parou.url) && slug(parou.q) === slug(q0) && slugDoLocal(parou.l) === slugDoLocal(l0);
    const itens = [chip('chip chip--cont', 'arrow-right', formatar(t.continuar, [q0, curto].filter(Boolean).join(' · ')), mesma ? formatar(t.parouNaVaga, parou.n) : '', { continuar: '1', q: q0, l: l0 || '', ...(mesma ? { href: parou.url } : {}) })];
    if (recentes[1]) {
        itens.push(chip('chip', 'clock-history', recentes[1][0], recentes[1][1], { q: recentes[1][0], l: recentes[1][1] || '' }));
    }
    caixa.replaceChildren(...itens);
    caixa.hidden = false;
    if (rotulo) {
        rotulo.hidden = false;
    }
}

// Volta do login ou do currículo no meio da candidatura (?vaga= e ?confirmar=1), de quando a home tinha a lista de vagas: a
// página da vaga termina pelo atalho /v{id} (que abre em português; só serve à transição, nada mais gera o ?vaga= na home).
function _abrirVagaDaVolta() {
    const q = new URLSearchParams(window.location.search);
    const id = +q.get('vaga');
    if (id) {
        window.location.replace(`/v${id}${q.get('confirmar') === '1' ? '?confirmar=1' : ''}`);
    }
}

// ---------- eventos ----------
function _iniciarEventos() {
    document.addEventListener('click', e => {
        const alvo = e.target;

        const sov = alvo.closest('[data-sov]');
        if (sov && cliqueComum(e)) {
            e.preventDefault();
            const campo = !ehCelular() && $(sov.dataset.sov === 'L' ? 'homeL' : 'homeQ');
            if (campo && campo.offsetParent) {
                window.scrollTo({ top: 0 });
                requestAnimationFrame(() => { campo.focus(); campo.select(); });
                return;
            }
            abrirSov(sov.dataset.sov);
            return;
        }

        const exp = alvo.closest('[data-exp]');
        if (exp) {
            document.querySelectorAll('#expTabs [data-exp]').forEach(b => {
                const on = b === exp;
                b.classList.toggle('is-on', on);
                b.setAttribute('aria-selected', String(on));
                b.tabIndex = on ? 0 : -1;
                $(b.getAttribute('aria-controls')).hidden = !on;
            });
            return;
        }

        if (alvo.closest('#scMais')) {
            const linha = $('homeShortcuts');
            linha.classList.add('is-all');
            $('scMais').setAttribute('aria-expanded', 'true');
            linha.children[4]?.focus();
            return;
        }

        const recente = alvo.closest('#homeRecent [data-q]');
        if (recente) {
            if (recente.dataset.href) {
                irPara(recente.dataset.href);
                return;
            }
            _buscar(recente.dataset.q, recente.dataset.l);
            return;
        }
    });

    $('homeForm')?.addEventListener('submit', e => {
        e.preventDefault();
        // A roda no botão até a busca abrir; voltando pelo cache do navegador, o botao.js a tira.
        const botao = e.currentTarget.querySelector('[type="submit"]');
        if (ocupado(botao)) {
            return;
        }
        ocupar(botao);
        _buscar($('homeQ').value, $('homeL').value);
    });

    // No celular o formulário da hero não aparece: o foco nele abre a busca em tela cheia.
    document.addEventListener('focusin', e => {
        if (ehCelular() && (e.target.id === 'homeQ' || e.target.id === 'homeL')) {
            e.target.blur();
            abrirSov(e.target.id === 'homeL' ? 'L' : 'Q');
        }
    });

    // Teclado do padrão de tablist (setas, Home e End) do "Explorar".
    document.addEventListener('keydown', e => {
        const lista = e.target.closest?.('#expTabs');
        if (!lista) {
            return;
        }
        const tabs = Array.from(lista.querySelectorAll('[role="tab"]'));
        const i = tabs.indexOf(document.activeElement);
        const destino = { ArrowRight: (i + 1) % tabs.length, ArrowLeft: (i - 1 + tabs.length) % tabs.length, Home: 0, End: tabs.length - 1 }[e.key];
        if (destino === undefined) {
            return;
        }
        e.preventDefault();
        tabs.forEach((t, j) => { t.tabIndex = j === destino ? 0 : -1; });
        tabs[destino].focus();
        tabs[destino].click();
    });
}

// ---------- início ----------
if ($('mpillL')) {
    $('mpillL').dataset.padrao = $('mpillL').textContent;
}
iniciarMedicaoPagina('home');
iniciarAutocomplete({
    campos: [
        { inp: $('homeQ'), tipo: 'q', ctx: 'd' },
        { inp: $('homeL'), tipo: 'l', ctx: 'd' },
        { inp: $('sovQ'), tipo: 'q', ctx: 'm' },
        { inp: $('sovL'), tipo: 'l', ctx: 'm' }
    ],
    textos: textosBusca,
    obterLocal,
    localDoTexto: _localDoTexto,
    aoEscolherLocal: local => {
        fecharSov();
        _trocarLocal({ ...local });
    },
    aoUsarLocalizacao: _usarLocalizacao
});
iniciarBuscaTelaCheia({
    valores: () => ({ q: $('homeQ')?.value || '', l: _textoDoLocal(_localAtual) }),
    aoBuscar: _buscar,
    aoUsarLocalizacao: _usarLocalizacao
});
_iniciarEventos();
_desenharRecentes();
_mostrarLocal(_localAtual);
_abrirVagaDaVolta();

// A conexão (Cloudflare) chega pelo GetUsuarioLogado; sem local escolhido, espera ela para hidratar.
(async () => {
    if (localEscolhido()) {
        _carregarLocal(_localAtual);
        return;
    }
    await obterUsuario();
    const conexao = localDaConexao();
    if (conexao && !_escolheuNaPagina) {
        _localAtual = conexao;
        _mostrarLocal(conexao);
        _carregarLocal(conexao);
    }
})();
